import {
  REQUEST_GEO_QUERY,
  RECEIVE_GEO_QUERY,
  REQUEST_GEO_TYPE_QUERY,
  RECEIVE_GEO_TYPE_QUERY,
  GEO_FAILED,
  API_CALL,
  UPLOAD_GEOGROUPS,
  UPLOAD_GEOGROUPS_RESULT,
  UPLOAD_GEOGROUPS_FAILED,
} from './types';

export const queryGeotargets = query => ({
  type: API_CALL,
  onRequest: REQUEST_GEO_QUERY,
  onResponse: RECEIVE_GEO_QUERY,
  onError: GEO_FAILED,
  payload: {
    method: 'GET',
    url: `/geotargets?${query}`
  },
  query
});

export const uploadGeogroups = csvString => ({
  type: API_CALL,
  onRequest: UPLOAD_GEOGROUPS,
  onResponse: UPLOAD_GEOGROUPS_RESULT,
  onError: UPLOAD_GEOGROUPS_FAILED,
  payload: {
    method: 'POST',
    url: `/geogroups/upload`,
    data: csvString
  }
});

export const getGeotargetsByType = () => ({
  type: API_CALL,
  onRequest: REQUEST_GEO_TYPE_QUERY,
  onResponse: RECEIVE_GEO_TYPE_QUERY,
  onError: GEO_FAILED,
  responseKey: 'geos',
  payload: {
    method: 'GET',
    url: `/geotargetsByType`
  },
});
